module.exports = __webpack_public_path__ + "static/media/2.0fc1db54.jpeg";